import { takeEvery, put, call } from "redux-saga/effects";
import {
    FETCH_CATEGORY_MAPPING,
    FETCH_CATEGORY_MAPPING_LIST,
    SAVE_CATEGROY_MAPPING_REQUEST
} from "./actionType";
import {
    fetchCategoryMappingSuccess,
    fetchCategoryMappingFailure,
    fetchCategoriesMappinglistSuccess,
    fetchCategoriesMappinglistgFailure,
    createCategorymappingSuccess,
    createCategorymappingFailure,
} from "./actions";
import { post } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";


// Fetch category mapping
function* fetchCategoryMappingSaga({ payload: { catId, unitId } }) {
    try {
        const formData = new FormData();
        formData.append("cat_id", catId);
        formData.append("unit_id", unitId);

        const response = yield call(post, process.env.REACT_APP_GET_CATEGORY_MAPPING, formData);

        console.log("Saga Response:", response);

        if (!response || response.status !== "success") {
            throw new Error(response?.message || "Failed!");
        }
        yield put(fetchCategoryMappingSuccess(response.data));

    } catch (error) {
        yield put(fetchCategoryMappingFailure(error.message));
    }
}

function* fetchCategoryMappinglsitSaga(action) {
    try {
        const response = yield call(post, process.env.REACT_APP_FETCH_GET_SALARY_MAP_LISTS, action.payload);

        console.log("Saga Response:", response);

        if (!response || response.status !== "success") {
            throw new Error(response?.message || "Failed!");
        }
        yield put(fetchCategoriesMappinglistSuccess(response));

    } catch (error) {
        yield put(fetchCategoriesMappinglistgFailure(error.message));
    }
}

// Create Categorymapping Saga
function* saveCategoryMappingSaga({ payload }) {
    try {
        const { formData, isEdit } = payload;
        const response = yield call(post, process.env.REACT_APP_SAVE_CATEGORY_MAPPING, formData);

        if (response?.status === "success") {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: response.message || "CategoryMapping saved successfully!",
            });
            yield put(createCategorymappingSuccess(response));
        } else {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Something went wrong!",
            });
            yield put(createCategorymappingFailure("Unexpected response format"));
        }
    } catch (error) {
        console.error("Saga API Error:", error);
        Swal.fire({
            icon: "error",
            title: "API Error",
            text: error.message || "An error occurred while saving the categoryMapping",
        });
        yield put(createCategorymappingFailure(error.message));
    }
}

export default function* categoryMappingSaga() {
    yield takeEvery(FETCH_CATEGORY_MAPPING, fetchCategoryMappingSaga);
    yield takeEvery(FETCH_CATEGORY_MAPPING_LIST, fetchCategoryMappinglsitSaga);
    yield takeEvery(SAVE_CATEGROY_MAPPING_REQUEST, saveCategoryMappingSaga);
}